import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ContactForm from "../ContactForm";
import { useLanguage } from "../../utils/LanguageContext";

const ComingSoon = () => {
  const navigate = useNavigate();
  const [showContactForm, setShowContactForm] = useState(false);
  const { language } = useLanguage();

  return (
    <>
      <div className="flex flex-col justify-center items-center min-h-screen bg-[#0f1d38] text-white px-4">

        {/* Back Button - LEFT */}
        <div className="w-full max-w-7xl flex justify-start mb-6 mt-2">
          <button
            onClick={() => navigate("/")}
            className="bg-transparent border border-[#4A7CFF] text-white px-4 py-2 rounded-full hover:bg-[#4A7CFF] transition duration-300"
          >
            ← Back 
          </button>
        </div>

        {/* Center Content */}
        <div className="text-center">

          <div className="mb-12">
            <div className="w-8 border-t-8 border-[#3B82F6] mx-auto mb-3"></div>

            <img
              alt="Professional"
              className="w-[350px] mx-auto"
              src="assests/images/Lexora1.svg"
            />
          </div>

          {/* Heading */}
          <div className="space-y-4 max-w-lg mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold">
              Something Exciting is{" "}
              <span className="gradient-text">Coming soon!</span>
            </h2>

            <p className="text-gray-300 text-lg">
              Stay tuned for updates and get ready to accelerate your business.
            </p>
          </div>

          {/* Button */}
          <button
            onClick={() => setShowContactForm(true)}
            className="mt-12 bg-transparent min-w-[190px] border-2 border-[#4A7CFF] text-white font-semibold px-4 py-2 rounded-full hover:bg-[#4A7CFF] transition duration-300"
          >
            Notify Me
          </button>

          {/* Footer */}
          <div className="mt-20 text-gray-400 text-sm max-w-md mx-auto">
            © 2024 Lexora S.L. All rights reserved.
          </div>
        </div>
      </div>

      {showContactForm && (
        <ContactForm
          onClose={() => setShowContactForm(false)}
          language={language}
        />
      )}
    </>
  );
};

export default ComingSoon;